import { mapValues } from '@exodus/basic-utils'

const encodeExperiments = (variants) =>
  Object.keys(variants).map((variant) => `${variant}:${variants[variant]}`)

const filterExperiments = ({ experiments, variants }) =>
  Object.fromEntries(Object.entries(variants).filter(([variant]) => experiments[variant]?.enabled))

const createAbTestingAnalyticsPlugin = ({ analytics, abTestingAtom }) => {
  let unsubscribe

  const onStart = () => {
    analytics.requireDefaultEventProperties(['experiments'])

    unsubscribe = abTestingAtom.observe((value) => {
      const experiments = value.experiments
      const variants = mapValues(value.variants, (i) => i.value)
      const out = encodeExperiments(filterExperiments({ experiments, variants }))

      analytics.setDefaultEventProperties({ experiments: out })
    })
  }

  return { onStart, onStop: () => unsubscribe?.() }
}

const abTestingAnalyticsPluginDefinition = {
  id: 'abTestingAnalyticsPlugin',
  type: 'plugin',
  factory: createAbTestingAnalyticsPlugin,
  dependencies: ['analytics', 'abTestingAtom'],
  public: true,
}

export default abTestingAnalyticsPluginDefinition
